const G = {
  border: "#1E1E1E", accent: "#00C896", muted: "#666",
  mono: "'DM Mono', monospace",
};

const tools = [
  { label: "B",      title: "Bold",        wrap: ["**", "**"],     placeholder: "bold text" },
  { label: "I",      title: "Italic",      wrap: ["*", "*"],       placeholder: "italic text" },
  { label: "`",      title: "Inline code", wrap: ["`", "`"],       placeholder: "code" },
  { label: "< >",   title: "Code block",  wrap: ["```\n", "\n```"],placeholder: "code block" },
  { label: "❝",      title: "Blockquote",  wrap: ["> ", ""],       placeholder: "quote" },
  { label: "• List", title: "Bullet list", wrap: ["- ", ""],       placeholder: "list item" },
  { label: "1. List",title: "Numbered list",wrap: ["1. ", ""],     placeholder: "list item" },
  { label: "—",      title: "Divider",     wrap: ["\n---\n", ""],  placeholder: "" },
];

export default function MarkdownToolbar({ textareaRef, value, onChange }) {
  const handleTool = (tool) => {
    const el = textareaRef.current;
    if (!el) return;
    const start = el.selectionStart;
    const end   = el.selectionEnd;
    const selected = value.slice(start, end) || tool.placeholder;
    const before = value.slice(0, start);
    const after  = value.slice(end);
    const newVal = before + tool.wrap[0] + selected + tool.wrap[1] + after;
    onChange(newVal);
    setTimeout(() => {
      el.focus();
      const cursor = start + tool.wrap[0].length + selected.length + tool.wrap[1].length;
      el.setSelectionRange(cursor, cursor);
    }, 0);
  };

  return (
    <div style={{
      display: "flex", flexWrap: "wrap", gap: 4,
      background: "#0D0D0D", border: `1px solid ${G.border}`,
      borderBottom: "none", borderRadius: "8px 8px 0 0",
      padding: "6px 8px",
    }}>
      {tools.map((tool) => (
        <button
          key={tool.title}
          title={tool.title}
          onClick={() => handleTool(tool)}
          type="button"
          style={{
            background: "#1A1A1A", border: `1px solid #2A2A2A`,
            color: G.muted, padding: "3px 10px", borderRadius: 5,
            cursor: "pointer", fontSize: 11, fontFamily: G.mono,
            transition: "all 0.15s", lineHeight: 1.6,
          }}
          onMouseOver={e => { e.currentTarget.style.borderColor = G.accent; e.currentTarget.style.color = G.accent; }}
          onMouseOut={e => { e.currentTarget.style.borderColor = "#2A2A2A"; e.currentTarget.style.color = G.muted; }}
        >
          {tool.label}
        </button>
      ))}
    </div>
  );
}
